import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule, PopoverController } from '@ionic/angular';

import { InboundEmail } from 'src/models';

@Component({
  standalone: true,
  selector: 'app-recipients-popover',
  imports: [CommonModule, IonicModule, RouterModule],
  templateUrl: './email-recipients-popover.component.html',
  styleUrls: ['./email-recipients-popover.component.css'],
})
export class RecipientsPopoverComponent {
  @Input() inboundEmail: Partial<InboundEmail>;

  constructor(private popoverCtrl: PopoverController) {}

  formatRecipient(recipient: any): string {
    if (typeof recipient === 'string') {
      return recipient;
    }

    if (recipient.name && recipient.email) {
      return `${recipient.name} <${recipient.email}>`;
    }

    return recipient.email;
  }

  formatFrom() {
    return this.formatRecipient({ name: this.inboundEmail.fromUser.name, email: this.inboundEmail.fromUser.email });
  }

  dismiss() {
    this.popoverCtrl.dismiss();
  }
}
